//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import footerAbstract from '@/assets/imgs/blog-footer-abstract.svg';
import abstract from '@/assets/imgs/post-abstract.svg';
import smallAbstract0 from '@/assets/imgs/small-abstract-1.svg';
import smallAbstract1 from '@/assets/imgs/small-abstract-2.svg';
import smallAbstract2 from '@/assets/imgs/small-abstract-3.svg';
import smallAbstract3 from '@/assets/imgs/small-abstract-4.svg';
import smallAbstract4 from '@/assets/imgs/small-abstract-5.svg';
import smallAbstract5 from '@/assets/imgs/small-abstract-6.svg';
import { page } from '@/mixins/wp-post';

export default {
  name: 'KnockPrivacy',

  mixins: [page('privacy')],

  data() {
    return {
      abstract,
      smallAbstract: [smallAbstract0, smallAbstract1, smallAbstract2, smallAbstract3, smallAbstract4, smallAbstract5],
      footerAbstract
    };
  },

  computed: {
    bannerSectionBg() {
      return `background: #131212 url("${abstract}") no-repeat scroll top right / auto 90%`;
    }
  }
};
